'use client'

import React, { useState } from 'react'
import posthog from 'posthog-js'
import { RichText } from '../RichText'
import { trackNewsletterSubscribed } from '../../lib/analytics'

interface NewsletterSignupProps {
  newsletterHeading?: any
  newsletterDescription?: string
  newsletterPlaceholder?: string
  newsletterButtonText?: string
}

export function NewsletterSignup({
  newsletterHeading,
  newsletterDescription,
  newsletterPlaceholder = 'Your Email Address',
  newsletterButtonText = 'Subscribe',
}: NewsletterSignupProps) {
  const [email, setEmail] = useState('')
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [message, setMessage] = useState('')

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setIsSubmitting(true)
    setMessage('')

    // TODO: Implement newsletter subscription
    setTimeout(() => {
      setIsSubmitting(false)
      setMessage('Thank you for subscribing!')
      posthog.identify(email, { source: 'newsletter_signup' })
      setEmail('')
      trackNewsletterSubscribed()
    }, 1000)
  }

  return (
    <section className="py-16 md:py-24 px-6 md:px-12 bg-background">
      <div className="max-w-3xl mx-auto text-center">
        {newsletterHeading && (
          <RichText
            data={newsletterHeading}
            className="prose prose-lg text-3xl md:text-4xl lg:text-5xl font-medium leading-tight text-gray-900 mb-4 md:mb-6 [&_p]:text-gray-900 [&_span.font-serif]:text-brand-gold [&_span.font-serif]:italic"
          />
        )}

        {newsletterDescription && (
          <p className="text-base md:text-lg text-gray-600 mb-8 md:mb-10 max-w-2xl mx-auto">
            {newsletterDescription}
          </p>
        )}

        <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3 max-w-xl mx-auto">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={newsletterPlaceholder}
            required
            className="flex-1 px-6 py-3 rounded-full bg-white border border-gray-300 focus:outline-none focus:ring-2 focus:ring-brand-blue focus:border-transparent text-gray-900 placeholder:text-gray-500"
          />
          <button
            type="submit"
            disabled={isSubmitting}
            className="px-8 py-3 bg-brand-blue text-white rounded-full hover:bg-brand-blue/90 transition-colors font-medium disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
          >
            {isSubmitting ? 'Subscribing...' : newsletterButtonText}
          </button>
        </form>

        {message && <p className="mt-4 text-sm text-green-600 font-medium">{message}</p>}
      </div>
    </section>
  )
}
